import { render, staticRenderFns } from "./MultipleImg.vue?vue&type=template&id=087538e7&scoped=true&"
import script from "./MultipleImg.vue?vue&type=script&lang=js&"
export * from "./MultipleImg.vue?vue&type=script&lang=js&"
import style0 from "./MultipleImg.vue?vue&type=style&index=0&id=087538e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087538e7",
  null
  
)

export default component.exports